import { useCallback, useContext } from "react";
import { AccessControlContext } from "../../access-control-context";

export const useRoles = () => {
  const accessControlContext = useContext(AccessControlContext);

  const { roles } = accessControlContext;

  const hasRole = useCallback(
    (role: string) => !roles || roles.includes(role),
    [roles]
  );

  const hasRoleThatContains = useCallback(
    (name: string) => !roles || roles.some((role) => role.includes(name)),
    [roles]
  );

  const hasAnyRoleThatContains = useCallback(
    (names: string[]) =>
      !roles || names.some((name) => roles.some((role) => role.includes(name))),
    [roles]
  );

  const hasAnyRole = useCallback(
    (targetRoles: string[]) =>
      !roles || targetRoles.some((targetRole) => roles.includes(targetRole)),
    [roles]
  );

  return {
    hasRole,
    hasAnyRole,
    hasRoleThatContains,
    hasAnyRoleThatContains,
  };
};
